<script setup lang="ts">
import Icon from '~/components/global/Icon.vue'

const isExpanded = ref(false)
</script>

<template>
  <div
    class="c-header-description"
    :class="{ 'c-header-description--expanded': isExpanded }"
  >
    <div id="listing-header-description" class="c-header-description__content">
      <slot />
    </div>

    <button
      type="button"
      class="c-header-description__toggle"
      aria-controls="listing-header-description"
      :aria-expanded="isExpanded"
      @click="isExpanded = !isExpanded"
    >
      {{
        isExpanded
          ? $t('pages.estateListing.header.description.showLess')
          : $t('pages.estateListing.header.description.showFull')
      }}
      <Icon :name="isExpanded ? 'chevron-up' : 'chevron-down'" />
    </button>
  </div>
</template>

<style lang="scss" scoped>
.c-header-description {
  &__content {
    :slotted(p) {
      margin: 0;
    }

    :slotted(p + p) {
      margin-top: 1rem;
    }
  }

  &:not(.c-header-description--expanded) &__content {
    :slotted(p:nth-of-type(2)) {
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    :slotted(p:nth-of-type(n + 3)) {
      display: none;
    }
  }

  &__toggle {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
    padding: 0;
    border: 0;
    background: none;
    color: var(--color-secondary);
    font: inherit;
    font-weight: 600;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }

    .ico {
      font-size: 10px;
    }
  }
}
</style>
